import DoNotDecryptRule from '../../entities/DoNotDecryptRule';

export default class UpdateDoNotDecryptRequestRule {

	id!: number;

	action!: string;

	operation!: string;

	description!: string;

	sourceIPs!: string;

	destinationIPs!: string;

	protocol!: string;

	service!: string;

	region!: string;

	destinationPorts!: string;

	trafficDirection!: string;

	ruleName!: string;

	constructor(rule: DoNotDecryptRule) { 
		Object.assign(this, rule);
		this.action = "Allow";
		this.operation = rule.operation?.name;
		this.region = rule.region?.name;
		this.trafficDirection = rule.trafficDirection?.name;
		this.ruleName = rule.name;
	}

}